import { render, staticRenderFns } from "./SlideCaptcha.vue?vue&type=template&id=59c8fe03&scoped=true"
import script from "./SlideCaptcha.vue?vue&type=script&lang=js"
export * from "./SlideCaptcha.vue?vue&type=script&lang=js"
import style0 from "./SlideCaptcha.vue?vue&type=style&index=0&id=59c8fe03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8fe03",
  null
  
)

export default component.exports